export default "__VITE_ASSET__BAwlCuBQ__"